import { CertificateFilePickerChangeEvent } from 'public/components/certificates/inputs/certificate-file-picker/types';

export const mergeSelectedFiles = (
  event: CertificateFilePickerChangeEvent,
  currentValue: File[] | undefined
): File[] => {
  const newFiles = Array.from<File>(event.target.files ?? []);
  const existingFiles = currentValue ?? [];

  return [...existingFiles, ...newFiles];
};
